import { ExtendedRouteConfig } from '@/router/types';
import SearchResults from './components/search-results/search-results.vue';
import ProductDetails from './components/product-details/product-details.vue';

export const productSearchRoutes: ExtendedRouteConfig[] = [
  {
    name: 'product-search/search',
    path: '/produktsuche',
    component: SearchResults,
    meta: {
      requiresAuth: true,
      title: 'Produktsuche',
    },
  },
  {
    name: 'product-search/product-details',
    path: '/produkt/:id',
    component: ProductDetails,
    meta: {
      requiresAuth: true,
      title: 'Produktdetails',
    },
  },
];
